import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function CheckoutCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-orange-100">
            <XCircle className="h-10 w-10 text-orange-600" />
          </div>
          <CardTitle className="text-2xl">Pagamento cancelado</CardTitle>
          <CardDescription>
            Você cancelou o processo de pagamento. Nenhuma cobrança foi realizada.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center space-y-4">
            <p className="text-sm text-muted-foreground">
              Se você mudou de ideia, pode tentar novamente a qualquer momento.
            </p>
            <div className="flex gap-2">
              <Button onClick={() => navigate('/dashboard')} variant="outline" className="flex-1">
                Voltar para o Dashboard
              </Button>
              <Button onClick={() => navigate(-1)} className="flex-1">
                Tentar novamente
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
